'use client';

import React from 'react';
import { IconSearch } from '@icons';
import { Button } from '@ui';

export interface SearchToggleProps {
  /**
   * Called when the user activates the control — e.g. `() => cmdkRef.current?.openPalette()`
   * for a **`CommandPalette`** mounted in the shell.
   */
  onOpen?: () => void;
  /** `aria-label` for the icon button (i18n). */
  ariaLabel?: string;
  /** Extra classes on the trigger (default **`btn-round`** — the project's round icon button style from `_actions.scss`). */
  className?: string;
}

const SearchToggle: React.FC<SearchToggleProps> = ({
  onOpen,
  ariaLabel = 'Open search',
  className = 'btn-round',
}) => {
  return (
    <Button
      className={className}
      as='button'
      type='button'
      aria-label={ariaLabel}
      label={<IconSearch />}
      onClick={() => onOpen?.()}
    />
  );
};

export default SearchToggle;
